import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import getSupabaseBrowserClient from "../../hooks/use-supabase-browser";
import { getVenue } from "../../api/get-venue";
import {
  useQuery,
  useInsertMutation,
} from "@supabase-cache-helpers/postgrest-react-query";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNotifications } from "../../providers/notifications";
import Page from "../../components/Page";
import { Tables } from "../../../utils/database.types";
import { useAuth } from "../../providers/auth";

const EditVenuePage: React.FC = () => {
  const navigate = useNavigate();
  const supabase = getSupabaseBrowserClient();
  const { oid } = useAuth();

  const {
    register,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm<Tables<"venues">>({ mode: "onChange" });

  const { notify } = useNotifications();

  useEffect(() => {
    reset({
      oid,
      timezone: "America/New_York",
      pricing_policy: "flat",
    });
  }, [oid]);

  const { mutate } = useInsertMutation(supabase.from("venues"), ["id"], "id", {
    onSuccess: () => {
      notify("Venue created successfully!", "success", 3000);
      navigate("/venues");
    },
    onError: (error) => {
      console.error("Error while updating the Venue:", error);
      notify(
        "Error while updating the venue. Please try again.",
        "error",
        3000
      );
    },
  });

  const onSubmit: SubmitHandler<Tables<"venues">> = (data) => mutate(data);

  return (
    <Page title={`Create a new venue`}>
      <div>
        <div className="card bg-base-100 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="card-body">
            <div className="form-control">
              <label className="label">
                <span className="label-text">Name</span>
              </label>
              <input
                type="text"
                {...register("name", { required: true })}
                className="input input-bordered"
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Phone Number</span>
              </label>
              <input
                type="tel"
                id="estimated_waiting_time"
                {...register("phone_number", {
                  required: true,
                })}
                className="input input-bordered"
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Estimated waiting time</span>
              </label>
              <input
                type="number"
                id="estimated_waiting_time"
                {...register("estimated_waiting_time", {
                  required: true,
                  min: 0,
                })}
                className="input input-bordered"
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span
                  className="label-text tooltip tooltip-right"
                  data-tip="The ID of the venue in the external system (ie. GetSling). This is used to link the venue to the external system."
                >
                  External ID ⓘ
                </span>
              </label>
              <input
                type="text"
                id="scheduler_ext_id"
                {...register("scheduler_ext_id", { required: true })}
                className="input input-bordered"
              />
            </div>
            <div className="flex gap-5">
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Accepts tips</span>{" "}
                </label>
                <input
                  type="checkbox"
                  id="tips"
                  {...register("tips")}
                  className="toggle toggle-sm"
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Accepts fee payment</span>{" "}
                </label>
                <input
                  type="checkbox"
                  id="payment"
                  {...register("payment")}
                  className="toggle toggle-sm"
                />
              </div>
            </div>
            <div className="flex justify-between" style={{ marginTop: "10px" }}>
              <button
                type="submit"
                className="btn btn-outline"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={!isValid}
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </Page>
  );
};

export default EditVenuePage;
